import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  featuredCardsGql,
  Query,
  FeaturedCard,
  LinkFeaturedCardData,
} from "@onmo/graphql/graphql";
import { GUIDE_VIDEOS_GROUP } from "../constants/videos";

const guideVideosQuery = {
  query: featuredCardsGql,
  variables: { input: { group: GUIDE_VIDEOS_GROUP } },
};

let apolloClient: ApolloClient<NormalizedCacheObject> | null = null;

/** Find a feature card's redirectUrl by its metadata.id in a query result. */
export const findCardRedirectUrl = (
  data: Query | null | undefined,
  id: string,
): string => {
  const items = (data?.featuredCards?.items ?? []) as FeaturedCard[];
  const card = items.find((c) => c?.metadata?.id === id);
  return (card?.data as LinkFeaturedCardData)?.redirectUrl ?? "";
};

export const getGuideVideoUrl = (id?: string): string => {
  if (!id || !apolloClient) return "";
  const data = apolloClient.readQuery<Query>(guideVideosQuery);
  return findCardRedirectUrl(data, id);
};

export const prefetchGuideVideos = (
  client: ApolloClient<NormalizedCacheObject>,
): void => {
  apolloClient = client;
  client.query<Query>(guideVideosQuery).catch(() => {
    /* best-effort; UI falls back to no video */
  });
};
